import { PaginaNode, SoluzioneNode } from '@gql/graphql'
import { CardGrid, GenericHero, Page, Prefooter } from 'components/organisms'
import styles from './SoluzioniTemplate.module.sass'

interface Props {
  pagina?: PaginaNode
  soluzioni?: SoluzioneNode[]
}

const SoluzioniTemplate = (props: Props) => {
  const { pagina = undefined, soluzioni = [] } = props

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <GenericHero pagina={pagina} />
        <CardGrid
          item={{
            spaceTop: 'md',
            children:
              soluzioni?.map((x) => ({
                pk: x.pk,
                name: x.title,
                url: x.url,
                image: x.image,
                imageAlt: x.imageAlt,
              })) || [],
          }}
        />
        <Prefooter />
      </main>
    </Page>
  )
}

export default SoluzioniTemplate
